// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spin {
  transition: background-color 1s ease;
  background-color: var(--primary-bg-color);
}
.spin.ant-spin.spin--full-page {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  height: 100vh;
  max-height: 100vh;
  z-index: 99999;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Spin/Spin.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EACA,yCAAA;AACJ;AACI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AACR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
